import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  useEngagementsSlots,
  useReschedule,
  useRescheduleWithComment,
} from "./store";
import EditPen from "assets/svgs/edit_pen";
import {
  Button,
  CloseButton,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import moment from "moment";
import 'moment-timezone';
import {
  getFormattedDate,
  convertDateStringToDate,
  convertDateToTime,
  formatDateTime,
  _formatDate,
  convertToIndianTime,
  getCurrentUserRole,
  engagementSlot,
} from "modules/utilities/utility";
import ReactDatePicker from "react-datepicker";
import EditPenList from "assets/svgs/edit_pen_list";
import { useNavigate } from "react-router-dom";

const timeDurations = {
  "10:00 AM": 0,
  "10:30 AM": 0,
  "11:00 AM": 0,
  "11:30 AM": 0,
  "12:00 PM": 0,
  "12:30 PM": 0,
  "01:00 PM": 0,
  "01:30 PM": 0,
  "02:00 PM": 0,
  "02:30 PM": 0,
  "03:00 PM": 0,
  "03:30 PM": 0,
  "04:00 PM": 0,
  "04:30 PM": 0,
  "05:00 PM": 0,
  "05:30 PM": 0,
  "06:00 PM": 0,
  "06:30 PM": 0,
  "07:00 PM": 0,
  "07:30 PM": 0,
  "08:00 PM": 0,
  "08:30 PM": 0,
  "09:00 PM": 0,
};

function Reschedule({ dueDate, id, item, list }) {
  const navigate = useNavigate();
  const { setToaster } = useToast();

  const [rescheduleDate, setRescheduleDate] = useState(
    item?.order?.reminder_date
  );
  const [timeSlot, setTimeSlot] = useState();
  const initialActiveDate = convertDateStringToDate(dueDate);
  const [activeDate, setActiveDate] = useState(initialActiveDate);
  const [modalShow, setModalShow] = useState(false);
  const { fetchEngagementSlots, engagementSlotsData } = useEngagementsSlots();
  const { putSetReschedule } = useReschedule();
  const { rescheduleWithComment } = useRescheduleWithComment();
  const [bookedSlots, setBookedSlots] = useState({});
  const [fullDaySlots, setFullDaySlots] = useState({});

  useEffect(() => {
    setTimeSlot(
      moment(getFormattedDate(dueDate), "MMM DD YYYY, h:mm a").format("hh:mm A")
    );
  }, [id]);
  useEffect(() => {
    if(engagementSlot.includes(getCurrentUserRole()) && modalShow){
         fetchEngagementSlots(activeDate);
    }
  }, [activeDate, fetchEngagementSlots, modalShow]);

  useEffect(() => {
    if (engagementSlotsData?.length) {
      const updatedBookedSlots = engagementSlotsData.reduce(
        (bookedSlotsObj, obj) => {
          const { count, reminder_date } = obj;
          const time = convertDateToTime(reminder_date);
          return { ...bookedSlotsObj, [time]: count };
        },
        {}
      );
      setBookedSlots(updatedBookedSlots);
    } else {
      setBookedSlots({});
    }
  }, [engagementSlotsData, activeDate]);

  useEffect(() => {
    const updatedFullDaySlots = Object.keys(timeDurations).reduce(
      (fullDaySlotsObj, time) => {
        return {
          ...fullDaySlotsObj,
          [time]: bookedSlots[time] || timeDurations[time],
        };
      },
      {}
    );
    setFullDaySlots(updatedFullDaySlots);
  }, [bookedSlots, activeDate]);

  const [comment, setComment] = useState();
  return (
    <>
      <OverlayTrigger
        placement="top"
        trigger={["hover", "focus"]}
        overlay={<Tooltip>{"Reschedule"}</Tooltip>}
      >
        {dueDate ? (
          <div
            className="flex-fill d-flex"
            onClick={() => {
              dueDate && setModalShow(true);
            }}
          >
            {list ? (
              <EditPenList />
            ) : (
              <button className="flex-1 px-2 btn btn-primary align-items-center">
                <EditPen />
              </button>
            )}
          </div>
        ) : (
          <div className="flex-fill d-flex disabled-action">
            {list ? (
              <EditPenList />
            ) : (
              <button className="flex-1 p-2 btn btn-secondary align-items-center">
                <EditPen />
              </button>
            )}
          </div>
        )}
      </OverlayTrigger>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Reschedule
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body style={{ height: "30%" }}>
          {item?.tag === "SLOT_BOOKING" ||
          item?.tag === "IVR_BOOKING" ||
          item?.tag === "FEEDBACK_CALL" ? (
            <div className="d-flex flex-column gap-3">
              <ReactDatePicker
                selected={rescheduleDate}
                minDate={new Date()}
                onChange={(selectedDate) => setRescheduleDate(selectedDate)}
                formatWeekDay={(day) => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select Date & Time"
                timeIntervals={30}
                dateFormat="MM/dd/yyyy h:mm aa"
                showTimeSelect
                fixedHeight
              />
              <div>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>
                    Comment<span className="text-danger"> *</span>
                  </Form.Label>
                  <Form.Control
                    required
                    as="textarea"
                    className="resize-none"
                    rows={5}
                    onChange={(event) => {
                      setComment(event.target.value);
                    }}
                  />
                </Form.Group>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-around">
              <Calendar
                defaultActiveStartDate={new Date(dueDate)}
                minDate={new Date(dueDate)}
                onChange={(selected) => {
                  setActiveDate(convertDateStringToDate(selected));
                }}
                defaultValue={convertToIndianTime(dueDate)}
              />

              <div
                style={{ background: "#F0F0F0" }}
                className="d-flex flex-column rounded"
              >
                <div className="p-2 border-bottom border-info">
                  <div className="d-flex py-3 px-2">
                    <strong className="mx-3">Time</strong>
                    <strong className="mx-3">Booking</strong>
                  </div>
                </div>
                <div
                  className="p-2 pb-0 scrollable-container"
                  style={{ height: "15.7rem", overflow: "scroll" }}
                >
                  {Object.entries(fullDaySlots).map(
                    ([time, booking], index) => (
                      <div
                        key={index}
                        className="d-flex justify-content-around align-items-start"
                      >
                        {}
                        <div className="flex-1 d-flex flex-column text-center booking p-0">
                          <input
                            type="radio"
                            id={time}
                            checked={time === timeSlot && "checked"}
                            name="time"
                            value={time}
                          />
                          <label
                            htmlFor={time}
                            onClick={() => setTimeSlot(time)}
                          >
                            {time}
                          </label>
                        </div>
                        <p className="flex-1 m-0 text-center">
                          {booking || "-"}
                        </p>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalShow(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            disabled={
              item?.tag === "SLOT_BOOKING" ||
              item?.tag === "IVR_BOOKING" ||
              item?.tag === "FEEDBACK_CALL"
                ? !(comment && rescheduleDate)
                : !(timeSlot && activeDate)
            }
            onClick={() => {
              item?.tag === "SLOT_BOOKING" ||
              item?.tag === "IVR_BOOKING" ||
              item?.tag === "FEEDBACK_CALL"
                ? rescheduleWithComment(
                    id,
                    rescheduleDate,
                    comment,
                    setToaster,
                    navigate
                  )
                : putSetReschedule(
                    id,
                    setToaster,
                    `${timeSlot}, ${_formatDate(activeDate)}`,
                    navigate
                  );
              setModalShow(false);
            }}
          >
            Reschedule
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Reschedule;
